module.exports = __webpack_public_path__ + "static_pc/img/gj01.99c3b0e4.png";